import { render, staticRenderFns } from "./PropertyDetail.vue?vue&type=template&id=ec437120&scoped=true&"
import script from "./PropertyDetail.vue?vue&type=script&lang=ts&"
export * from "./PropertyDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyDetail.vue?vue&type=style&index=0&id=ec437120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec437120",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDivider,VRow,VSelect,VTextField})
